import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck, faTimes, faTrashAlt, faEdit, faStar } from '@fortawesome/free-solid-svg-icons';
import '../../styles/AdminDataTable.css';

const ReviewsTable = ({ 
  reviews, 
  selectedReviews, 
  onReviewSelect, 
  onSelectAll, 
  onApproveReview, 
  onRejectReview, 
  onDeleteReview,
  onEdit 
}) => {
  const getStatusBadge = (review) => {
    if (review.is_approved) {
      return <span className="status-badge approved">Approved</span>;
    } else {
      return <span className="status-badge rejected">Rejected</span>;
    }
  };

  const renderStars = (rating) => {
    return Array.from({ length: 5 }, (_, index) => {
      const starValue = index + 1;
      const isFilled = starValue <= rating;
      
      return (
        <FontAwesomeIcon
          key={index}
          icon={faStar}
          className={`star ${isFilled ? 'filled' : 'empty'}`}
          style={{ fontSize: '0.875rem' }}
        />
      );
    });
  };

  return (
    <div className="admin-data-table__container">
      <table className="admin-data-table">
        <thead>
          <tr>
            <th>
              <input
                type="checkbox"
                checked={selectedReviews.length === reviews.length && reviews.length > 0}
                onChange={onSelectAll}
              />
            </th>
            <th>ID</th>
            <th>Reviewer</th>
            <th>Email</th>
            <th>Boat</th>
            <th>Rating</th>
            <th>Comment</th>
            <th>Status</th>
            <th>Created At</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {reviews.map((review) => (
            <tr key={review.id}>
              <td>
                <input
                  type="checkbox"
                  checked={selectedReviews.includes(review.id)}
                  onChange={() => onReviewSelect(review.id)}
                />
              </td>
              <td>#{review.id}</td>
              <td>{review.reviewer_name}</td>
              <td>{review.email}</td>
              <td>{review.boat?.name || '-'}</td>
              <td>
                <div className="rating-display">
                  {renderStars(review.rating)}
                  <span className="rating-text">({review.rating})</span>
                </div>
              </td>
              <td>
                <div className="comment-cell">
                  {review.comment ? (
                    review.comment.length > 50 
                      ? `${review.comment.substring(0, 50)}...` 
                      : review.comment
                  ) : '-'}
                </div>
              </td>
              <td>{getStatusBadge(review)}</td>
              <td>{review.formatted_created_at}</td>
              <td>
                <div className="action-buttons">
                  <button
                    className="button secondary"
                    onClick={() => onDeleteReview(review.id)}
                    title="Delete Review"
                  >
                    <FontAwesomeIcon icon={faTrashAlt} />
                  </button>
                  <button
                    className="button secondary"
                    onClick={() => onEdit(review)}
                    title="Edit Review"
                  >
                    <FontAwesomeIcon icon={faEdit} />
                  </button>
                  <button
                    className="button secondary"
                    onClick={() => onApproveReview(review.id)}
                    title="Approve Review"
                  >
                    <FontAwesomeIcon icon={faCheck} />
                  </button>
                  <button
                    className="button secondary"
                    onClick={() => onRejectReview(review.id)}
                    title="Reject Review"
                  >
                    <FontAwesomeIcon icon={faTimes} />
                  </button>
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default ReviewsTable; 